import Banner, {BannerTypes} from 'patient-ping-remedy/packages/banner';
import {BannerWrapper} from '@common/AiWorkingBanner.styles';

type Props = {
  className?: string;
}

export default function AiWorkingBanner({className}: Props) {
  return (
    <BannerWrapper className={className}>
      <Banner type={BannerTypes.INFORMATIONAL}>
        AI is working this Task. Please do not reach out to the client at this time.
      </Banner>
    </BannerWrapper>
  );
}
